import { render, staticRenderFns } from "./ProjectsResultsDetails.vue?vue&type=template&id=6a4486e8&"
import script from "./ProjectsResultsDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectsResultsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports